import React, { useEffect, useRef } from 'react'
import { useLocation } from '@reach/router'

export default ({ anchorName, alignBlock = 'start' }) => {
  const element = useRef(null)
  const location = useLocation()

  useEffect(() => {
    const hash = location.hash

    if (!element || !element.current || !hash) return

    if (hash.substr(1) === element.current.id) {

      /* We need a timeout for it to work in Chrome.
       * Chrome is to fast so the action fires before Chrome's default scroll to html anchor event
       * */
      setTimeout(() => {
          element.current.scrollIntoView({
            behavior: 'smooth',
            block: alignBlock
          })
        }
        , 10)
    }
  }, [location])

  return <div id={ anchorName } ref={ element }/>
}